export enum VehicleImageEnum {
    FullVehicle,
    RegistrationPlate,
    FrontOfVehicle
}

export type BinaryRecordDetailsType = {
    image: string;
    vehicleId: number;
    imageType: VehicleImageEnum;
}
